import React, { useState } from "react";
import FleetrifyCard from "../../components/Card";
import DashboardLayout from "../../components/DashboardLayout";
import { optionIcon } from "../../components/pages/Dashboard/items";
import TotalOrders from "../../components/pages/Analysis/TotalOrders";
import { useDashboardControllers } from "../../controllers/useDashboardControllers";
import { DashboardFleetSummaryCard } from "../../components/pages/Dashboard/Cards/summary";
import { fleetrifyIcons } from "../../assets/icons/icons";
import OrderStatusPerLocation from "../../components/pages/Analysis/OrderStatus";
import OrderPerDelivery from "../../components/pages/Analysis/OrderPerDelivery";
import OrdersByVehicles from "../../components/pages/Analysis/OrdersByVehicles";
import DepartmentBreakdown from "../../components/pages/Analysis/DepartmentBreakdown";
import ServicesRendered from "../../components/pages/Analysis/ServicesRendered";
import FleetrifySecondCard from "../../components/pages/Analysis/Growth";
import FleetrifyThirdCard from "../../components/pages/Analysis/GrowthSecond";
import SentVsReceived from "../../components/pages/Analysis/SentVsReceived";
import MessagesStages from "../../components/pages/Analysis/MessageStages";
import CompletedVsCancelled from "../../components/pages/Analysis/CompletedVsCancelled";
import TotalOrdersByServices from "../../components/pages/Analysis/TotalOrdersByServices";
import TotalOrdersProcessed from "../../components/pages/Analysis/TotalOrdersProcessed";
import { DashboardFleetSummaryCardTwo } from "../../components/pages/Dashboard/Cards/twobar";
import MostRequested from "../../components/pages/Analysis/MostRequested";


const Reports = () => {
  const [currentSection, setCurrentSection] = useState<string>("order");

  const { dateRange, handleDateRangeChange } = useDashboardControllers();

  const switchSection = (newSection: string) => setCurrentSection(newSection);

  return (
    <>
      <DashboardLayout
        title="Order Report"
        description="Get a clear, actionable view of your staff and operations in one place. Track key metrics, and export the data you need to make faster, smarter decisions every day."
        containerClass="pb-10"
        dateRange={dateRange}
        onDateRangeChange={handleDateRangeChange}
        showDateRange={true}
        onDataRefresh={() => console.log("Data refreshed")}
      >
        <div className="flex flex-col md:flex-row justify-between mt-5">

          {/* sub tab Options */}
          <div className="grid grid-cols-3 gap-2 md:flex md:flex-row md:gap-2 mt-2">
            {[
              { key: "order", label: "Order" },
              { key: "fleet", label: "Fleet" },
              { key: "services", label: "Service" },
              { key: "branch", label: "Branch" },
              { key: "staff", label: "Staff" },
              { key: "messages", label: "Messages" },
            ].map((tab) => (
              <div
                key={tab.key}
                onClick={() => switchSection(tab.key)}
                className={`
        cursor-pointer px-3 py-2 text-sm text-center
        ${currentSection === tab.key
                    ? "bg-[#143887] text-white font-semibold rounded-lg md:rounded-none md:bg-transparent md:text-[#143887] md:border-b-2 md:border-[#143887]"
                    : "text-gray-600 border border-gray-300 rounded-lg md:rounded-none md:border-0 md:hover:text-[#143887]"
                  }
      `}
              >
                {tab.label}
              </div>
            ))}
          </div>

          {/* Export Powerpoint Button */}

          <div className="mt-8 flex justify-end">
            <button className="bg-[#143887] text-white px-6 py-2 rounded-md">
              Export Powerpoint
            </button>
          </div>

        </div>

        <main className="space-y-10">

          {/* summary card group for all sub tab on report */}
          {/* Default Order Services */}
          {currentSection === "order" && (
            <div className="flex flex-col lg:flex-col gap-4 w-full h-full space-y-4">
              <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
                <h3 className="text-sm font-semibold text-[#00032A] mb-4">
                  Summary
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  <DashboardFleetSummaryCard
                    title="Total Orders"
                    value={276}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.vehicleLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Fulfilled Orders"
                    value={239}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.activeTipLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Cancelled Orders"
                    value={23}
                    changeText="2% Up from last quarter"
                    changeDirection="down"
                    icon={fleetrifyIcons.requestIcon}
                  />
                  <DashboardFleetSummaryCard
                    title="Orders in Progress"
                    value={14}
                    changeText="40% Up from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.dutyIcon}
                  />
                </div>
              </section>
              {/* real time fleet map */}
              <FleetrifyCard cardContainerClass="space-y-5 h-full">
                <div className="w-full h-full mt-4">
                  <div className="my-2 flex flex-row justify-between">
                    <p className="font-bold text-[16px]">Total Orders</p>
                    <select className="appearance-none bg-gray-100 border border-gray-500 text-[#4F4F4F] rounded-md px-5 py-2 text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-500">
                      <option value="Lagos">Lagos</option>
                      <option value="London">Ogun</option>
                      <option value="California">Oyo</option>
                      <option value="California">Osun</option>
                      <option value="California">Others</option>
                    </select>
                  </div>
                  <TotalOrders />
                  <div className="flex gap-4 mx-auto pt-6 justify-center items-center">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Fulfilled Orders</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>Cancelled</p>
                    </div>
                  </div>
                </div>
              </FleetrifyCard>

              {/* Fleetrify activity chart */}
              <div className="flex flex-col lg:flex-row gap-4 w-full h-full">
                <FleetrifyCard cardContainerClass="space-y-5 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center pb-5">
                    <div>
                      <h3 className="text-lg font-semibold text-[#00032A]">
                        Order Status Per Location
                      </h3>
                    </div>
                    <button>{optionIcon}</button>
                  </div>

                  <OrderStatusPerLocation />

                  <div className="flex gap-4 mx-auto pt-6 items-center flex-wrap">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Lagos</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>Ogun</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#3CC3DF]"></span>
                      <p>Oyo</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#FFAE4C]"></span>
                      <p>Osun</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#6226EF]"></span>
                      <p>Others</p>
                    </div>
                  </div>
                </FleetrifyCard>

                <FleetrifyCard cardContainerClass="space-y-5 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center pb-5">
                    <div>
                      <h3 className="text-lg font-semibold text-[#00032A]">
                        Order Per Delivery Area
                      </h3>
                    </div>
                    <button>{optionIcon}</button>
                  </div>

                  <OrderPerDelivery />

                  <div className="flex gap-4 mx-auto pt-6 items-center">
                    <span className="h-2 w-2 bg-[#6226EF]"></span>
                    <p>Total Orders Per Delivery Area</p>
                  </div>
                </FleetrifyCard>
              </div>
            </div>
          )}


          {/* Fleet services */}
          {currentSection === "fleet" && (
            <div className="flex flex-col lg:flex-col gap-4 w-full h-full space-y-4">
              <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
                <h3 className="text-sm font-semibold text-[#00032A] mb-4">
                  Summary
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                  <DashboardFleetSummaryCardTwo
                    title="Total Vehicles"
                    value={262}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.vehicleLogo}
                  />
                  <DashboardFleetSummaryCardTwo
                    title="Active Vehicles"
                    value={239}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.activeTipLogo}
                  />
                </div>
              </section>
              {/* real time fleet map */}
              {/* <FleetrifyCard cardContainerClass="space-y-5 h-full">
                <div className="w-full h-full mt-4">
                  <div className="my-2 flex flex-row justify-between">
                    <p className="font-bold text-[16px]">Total Orders</p>
                    <select
                      className="appearance-none bg-gray-100 border border-gray-500 text-[#4F4F4F] rounded-md px-5 py-2 text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="Lagos">Lagos</option>
                      <option value="London">Ogun</option>
                      <option value="California">Oyo</option>
                      <option value="California">Osun</option>
                      <option value="California">Others</option>
                    </select>
                  </div>
                  
                  <div className="flex gap-4 mx-auto pt-6 justify-center items-center">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Fulfilled Orders</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>Cancelled</p>
                    </div>
                  </div>
                </div>
              </FleetrifyCard> */}

              {/* Fleetrify activity chart */}
              <div className="flex flex-col lg:flex-row gap-4 w-full h-full">
                <FleetrifyCard cardContainerClass="space-y-2 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center pb-5">
                    <div>
                      <h3 className="text-lg font-semibold text-[#00032A]">
                        Total Orders By Vehicles
                      </h3>
                    </div>
                  </div>

                  <OrdersByVehicles />

                  <div className="flex gap-4 mx-auto pt-6 items-center flex-wrap">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Maintenance</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>Repairs</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#3CC3DF]"></span>
                      <p>Others</p>
                    </div>
                  </div>
                </FleetrifyCard>

                <FleetrifyCard cardContainerClass="space-y-5 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center pb-5">
                    <div>
                      <h3 className="text-lg font-semibold text-[#00032A]">
                        Total orders by Services
                      </h3>
                    </div>
                  </div>

                  <TotalOrdersByServices />

                  <div className="flex gap-4 mx-auto pt-6 items-center">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#6226EF]"></span>
                      <p>Maintenance</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>Repairs</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#3CC3DF]"></span>
                      <p>Others</p>
                    </div>
                  </div>
                </FleetrifyCard>
              </div>
            </div>
          )}

          {/* Services services */}
          {currentSection === "services" && (
            <div className="flex flex-col lg:flex-col gap-4 w-full h-full space-y-4">
              <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
                <h3 className="text-sm font-semibold text-[#00032A] mb-4">
                  Summary
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  <DashboardFleetSummaryCard
                    title="Total Services Rendered"
                    value={6}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.vehicleLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Active Services"
                    value={6}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.activeTipLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Completed Services"
                    value={6}
                    changeText="2% from last quarter"
                    changeDirection="down"
                    icon={fleetrifyIcons.requestIcon}
                  />
                  <DashboardFleetSummaryCard
                    title="Cancelled Services"
                    value={5}
                    changeText="2% Up from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.dutyIcon}
                  />
                </div>
              </section>

              {/* Fleetrify activity chart */}
              <div className="flex flex-col lg:flex-row gap-4 w-full h-full">
                <FleetrifyCard cardContainerClass="space-y-5 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center pb-5">
                    <div>
                      <h3 className="text-lg font-semibold text-[#00032A]">
                        Services Rendered
                      </h3>
                    </div>
                  </div>

                  <ServicesRendered />

                  <div className="flex gap-4 mx-auto pt-6 items-center flex-wrap">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Services in filtered period</p>
                    </div>
                  </div>
                </FleetrifyCard>

                <FleetrifyCard cardContainerClass="space-y-5 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center mb-3">
                    <div>
                      <h3 className="text-lg font-semibold text-[#00032A]">
                        Most Requested Service
                      </h3>
                    </div>
                    <button>{optionIcon}</button>
                  </div>

                  <MostRequested />


                </FleetrifyCard>
              </div>
            </div>
          )}

          {/* Branch services */}
          {currentSection === "branch" && (
            <div className="flex flex-col lg:flex-col gap-4 w-full h-full space-y-4">
              <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
                <h3 className="text-sm font-semibold text-[#00032A] mb-4">
                  Summary
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  <DashboardFleetSummaryCard
                    title="Total Branches"
                    value={8}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.vehicleLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Total Orders (All Branched)"
                    value={280}
                    changeText="2% from last quarter"
                    changeDirection="down"
                    icon={fleetrifyIcons.activeTipLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Orders Handled This Week"
                    value={1450}
                    changeText="2% Up from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.requestIcon}
                  />
                </div>
              </section>
              {/* real time fleet map */}
              <FleetrifyCard cardContainerClass="space-y-5 h-full">
                <div className="w-full h-full mt-4">
                  <div className="my-2 flex flex-row justify-between">
                    <p className="font-bold text-[16px]">Total Orders Processed</p>

                  </div>
                  <TotalOrdersProcessed />
                  <div className="flex gap-4 mx-auto pt-6 justify-center items-center">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Fulfilled Orders</p>
                    </div>
                  </div>
                </div>
              </FleetrifyCard>

              {/* Fleetrify activity chart */}
              <div className="flex flex-col lg:flex-row gap-4 w-full h-full">
                <FleetrifyCard cardContainerClass="space-y-2 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center pb-2">
                    <div>
                      <h3 className="text-sm font-semibold text-[#00032A]">
                        Completed vs Cancelled Orders Per branch
                      </h3>

                    </div>
                    <select className="appearance-none bg-gray-100 border border-gray-500 text-[#4F4F4F] rounded-lg px-3 py-2 text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-500">
                      <option value="Lagos">Lagos</option>
                      <option value="London">Ogun</option>
                      <option value="California">Oyo</option>
                      <option value="California">Osun</option>
                      <option value="California">Others</option>
                    </select>
                  </div>

                  <p>Lagos Branch</p>
                  <CompletedVsCancelled />

                  <div className="flex gap-4 mx-auto pt-6 items-center flex-wrap">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Completed</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>Cancelled</p>
                    </div>
                  </div>
                </FleetrifyCard>

                <FleetrifySecondCard cardContainerClass="space-y-5 h-full lg:w-1/2 w-full"
                  subheader="Top 3"
                  header="Growth Analysis"
                  firstState="Osun"
                  firstOrders="60 orders"
                  firstButton="+46%"
                  secondState="Lagos"
                  secondOrders="40 orders"
                  secondButton="12%"
                  thirdState="Rivers"
                  thirdOrders="20 orders"
                  thirdButton="5%"
                />

                <FleetrifyThirdCard cardContainerClass="space-y-5 h-full lg:w-1/2 w-full"
                  subheader="Bottom 3"
                  header="Branches for Improvement"
                  firstState="Oyo"
                  firstOrders="Customer unavailability"
                  firstButton="32%"
                  secondState="Delta"
                  secondOrders="Payment Issues"
                  secondButton="15.5%"
                  thirdState="Ondo"
                  thirdOrders="Customer unavailability"
                  thirdButton="8%"
                  firstCancelled="40 cancelled"
                  secondCancelled="25 cancelled"
                  thirdCancelled="9 cancelled"
                />


              </div>
            </div>
          )}

          {/* Staff Services */}
          {currentSection === "staff" && (
            <div className="flex flex-col lg:flex-col gap-4 w-full h-full space-y-4">
              <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
                <h3 className="text-sm font-semibold text-[#00032A] mb-4">
                  Summary
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  <DashboardFleetSummaryCard
                    title="Total Staff"
                    value={120}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.vehicleLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Total Drivers"
                    value={45}
                    changeText="2% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.activeTipLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Active Staff"
                    value={95}
                    changeText="2% Up from last quarter"
                    changeDirection="down"
                    icon={fleetrifyIcons.requestIcon}
                  />
                  <DashboardFleetSummaryCard
                    title="Inactive Staff"
                    value={25}
                    changeText="40% Up from last quarter"
                    changeDirection="down"
                    icon={fleetrifyIcons.dutyIcon}
                  />
                </div>
              </section>
              {/* real time fleet map */}
              <FleetrifyCard cardContainerClass="space-y-5 h-full">
                <div className="w-full h-full mt-4">
                  <div className="my-2 flex flex-row justify-between">
                    <p className="font-bold text-[16px]">Department Breakdown</p>

                  </div>
                  <DepartmentBreakdown />
                  <div className="flex gap-4 mx-auto pt-6 justify-center items-center">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Active</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>Inactive</p>
                    </div>
                  </div>
                </div>
              </FleetrifyCard>

              {/* Fleetrify activity chart */}
            </div>
          )}

          {/* Messages services */}
          {currentSection === "messages" && (
            <div className="flex flex-col lg:flex-col gap-4 w-full h-full space-y-4">
              <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
                <h3 className="text-sm font-semibold text-[#00032A] mb-4">
                  Summary
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  <DashboardFleetSummaryCard
                    title="Total Messages"
                    value={1842}
                    changeText="8% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.vehicleLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="Open Tickets"
                    value={134}
                    changeText="3% from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.activeTipLogo}
                  />
                  <DashboardFleetSummaryCard
                    title="In Progress"
                    value={58}
                    changeText="5% Up from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.requestIcon}
                  />
                  <DashboardFleetSummaryCard
                    title="Resolved"
                    value={1650}
                    changeText="12% Up from last quarter"
                    changeDirection="up"
                    icon={fleetrifyIcons.dutyIcon}
                  />
                </div>
              </section>

              <div className="flex flex-col lg:flex-row gap-4 w-full h-full">
                <FleetrifyCard cardContainerClass="space-y-2 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center pb-5">
                    <div>
                      <h3 className="text-lg font-semibold text-[#00032A]">
                        Sent vs Received Messages
                      </h3>
                    </div>
                  </div>

                  <SentVsReceived />

                  <div className="flex gap-4 mx-auto pt-6 items-center flex-wrap">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Sent</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>Received</p>
                    </div>
                  </div>
                </FleetrifyCard>

                <FleetrifyCard cardContainerClass="space-y-2 h-full lg:w-1/2 w-full">
                  <div className="flex justify-between items-center pb-5">
                    <div>
                      <h3 className="text-lg font-semibold text-[#00032A]">
                        Messages Stages
                      </h3>
                    </div>
                  </div>

                  <MessagesStages />

                  <div className="flex gap-4 mx-auto pt-6 items-center flex-wrap">
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#6226EF]"></span>
                      <p>Open</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#E41B1B]"></span>
                      <p>In Progress</p>
                    </div>
                    <div className="flex gap-2 items-center">
                      <span className="h-2 w-2 bg-[#1970E6]"></span>
                      <p>Resolved</p>
                    </div>
                  </div>
                </FleetrifyCard>
              </div>
            </div>
          )}

        </main>
      </DashboardLayout>
    </>
  );
};
export default Reports;




